import { IGetOneResponse } from '../util/Types/Generic';
import { ApiService } from './ApiService';

interface GetGoogleSlidesFromDriveResponse {
  presentations: {
    id: string;
    name: string;
  }[];
}

export class PullDataService extends ApiService {
  static readonly pathName = '/pull-data';

  static readonly getWorksheetData = (body: {
    googleAccessToken: string;
    spreadsheetId: string;
    rangeFilter: string;
    sheets: number;
  }): Promise<IGetOneResponse<any>> => {
    return ApiService.post(`${this.pathName}/get-worksheet-data`, body);
  };

  static readonly getGoogleSlidesFromDrive = (body: {
    googleAccessToken: string;
  }): Promise<IGetOneResponse<GetGoogleSlidesFromDriveResponse>> => {
    return ApiService.post(
      `${this.pathName}/get-presentations-from-drive`,
      body,
    );
  };

  static readonly getGoogleSlidesData = (body: {
    googleAccessToken: string;
    presentationId: string;
    slides: string;
  }): Promise<IGetOneResponse<any>> => {
    return ApiService.post(`${this.pathName}/get-presentation-data`, body);
  };
}
